import { render, staticRenderFns } from "./AddExpensesType.vue?vue&type=template&id=47603f3c&scoped=true&"
import script from "./AddExpensesType.vue?vue&type=script&lang=js&"
export * from "./AddExpensesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47603f3c",
  null
  
)

export default component.exports